export default __webpack_public_path__ + "static/media/Figure 8 drill.efc40dfd.jpg";